export default "__VITE_ASSET__cd69994e__"